import { FC } from 'react'
import styles from './CardBackgroundImage.module.scss'
import { CmsResponsiveImage } from '../Sections/PageHero'
import { DynamicImage } from '../DynamicImage'

export interface CardBackgroundImageProps {
  image: CmsResponsiveImage
}

export const CardBackgroundImage: FC<CardBackgroundImageProps> = ({
  image,
}) => {
  return (
    <div className={styles.bgImageContainer}>
      <DynamicImage
        className={styles.bgImage}
        image={image}
        alt={image.fields.title}
        fill
        sizes="100vw"
      />
    </div>
  )
}
